<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12w9yWx/tc-custom/9781426883279.jpg?1721442252553" alt="This image is the cover for the book Millionaire's Revenge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Millionaire's Revenge
      </h1>
      <p class="bookDescription body article font2">
        <b>A tycoon turns the tables on the woman who rejected his marriage proposal in this classic romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>Years ago, Laura Jackson was shocked by Gabriel Greppi’s proposal of marriage—but she turned him down. She wasn’t ready for a walk down the aisle . . .<br/><br/>Gabriel has never forgiven Laura. Now he’s a multimillionaire—and Laura is on the verge of bankruptcy. He plans to seduce her again and then reject her, as she rejected him all those years ago. The first part is easy—the passion still burns strong between them. But, as Gabriel discovers, the second part is not so easy . . .<br/><br/><i>Originally published in 2002</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cathy Williams
      </h2>
      
      <p class="authorDescription body article">Cathy Williams is a great believer in the power of perseverance as she had never written anything before her writing career, and from the starting point of zero has now fulfilled her ambition to pursue this most enjoyable of careers. She would encourage any would-be writer to have faith and go for it! She derives inspiration from the tropical island of Trinidad and from the peaceful countryside of middle England. Cathy lives in Warwickshire her family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17bffd97